/* eslint-disable camelcase */
import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Link, Redirect} from 'react-router-dom';
import {actions, Control, Errors, Form} from 'react-redux-form';
import {Button, Checkbox, Col, Grid, Row} from 'react-bootstrap';
import qs from 'qs';
import PageTitle from '../common/page-title';
import ErrorMessages from '../login/error-messages';
import RequiredPasswordMaskInput from '../common/form/elements/required-password-mask-input';
import UserTitleSelector from '../common/form/user/user-title-selector';
import UserFirstNameInput from '../common/form/user/user-first-name-input';
import UserLastNameInput from '../common/form/user/user-last-name-input';
import DateOfBirthSelector from '../common/form/user/date-of-birth-selector';
import SecurityQuestionAnswer from '../common/form/user/security-question-answer-input';
import {getInvitationInfo, getQuestions, saveAboutYouOwner, saveAboutYouStaff} from '../../actions/about-you';
import {isAdminLoggedIn} from '../../utils/tokenUtils';
import './style.css';
import TextViewer from '../common/editor/text-viewer';
import MarketingPreferences from './marketing-preferences';
import { tradeSiteEnabled } from '../../utils/toggles';
import CommunicationPreferences from '../common/form/user/communication-preferences';
import CommunicationDetails from '../common/form/user/communication-details';
import IgniteUkLogo from '../../assets/img/ignite_logo_black.png';

class InformationsAboutYou extends Component {
  state = {};
  onNextClicked = (payload) => {
    const {dispatch, registration} = this.props;
    const {invitation_token} = this;

    if (invitation_token) {
      dispatch(actions.submitFields('deep.about_you.user', saveAboutYouStaff(payload, registration, invitation_token)));
    } else {
      dispatch(actions.submitFields('deep.about_you.user', saveAboutYouOwner(payload, registration)));
    }
  };
  constructor(props) {
    super(props);
    const {dispatch} = this.props;

    if (props.location.search) {
      const params = qs.parse(props.location.search.slice(1));
      if (params.invitation_token) {
        this.invitation_token = params.invitation_token;
        dispatch(getInvitationInfo(params.invitation_token));
      }
    }
    dispatch(getQuestions());
  }

  render() {
    const {
      // eslint-disable-next-line max-len
      eircode, passcode, questions, t_cs1, t_cs2, t_cs_champion, formValid, customer_number, champion, commsEmail, commsMobile, marketingAccepted
    } = this.props;
    const {invitation_token} = this;

    if (!(eircode || passcode || invitation_token || isAdminLoggedIn() || tradeSiteEnabled())) {
      return (<Redirect to="/registration/outlet"/>);
    }
    return (
      <Form
        className="register-about-you"
        model="deep.about_you.user"
        onSubmit={this.onNextClicked}
      >
        <Errors
          className="errors"
          component={ErrorMessages}
          model="deep.about_you.user"
        />
        <Grid className="user-inner-container">
          <Row>
            <Col lg={12}>
              <img src={IgniteUkLogo} alt="Ignite UK" />
              <PageTitle>
                About you
              </PageTitle>
              <div className="inline-editor">
                <TextViewer pageSlug='about-you' className="editable"/>
              </div>
            </Col>
            <Col lg={6}>
              <UserTitleSelector model="deep.about_you.user.title"/>

              <UserFirstNameInput/>

              <UserLastNameInput/>

              <DateOfBirthSelector/>

              <CommunicationDetails/>

              <div className="marketing-preferences">
                <MarketingPreferences
                  title={(
                    <div className="marketing-label">Marketing preferences*</div>
                  )}
                  type="register"
                  customer_number={customer_number}
                  invitation={this.invitation_token}
                />
              </div>

              {marketingAccepted === 'true' && (
                <CommunicationPreferences
                  commsEmail={commsEmail}
                  commsMobile={commsMobile}
                  marketing={marketingAccepted}
                  model={'deep.about_you.user'}
                />
              )}
            </Col>

            <Col lg={6}>
              <div className="password-label">
                Password
              </div>
              <RequiredPasswordMaskInput
                controlId="newPassword"
                label="The password must be a minimum of 8 characters and contain one uppercase, one
              lowercase, and one number."
                model=".password"
              />

              <RequiredPasswordMaskInput
                controlId="passwordConfirm"
                label="Confirm Password"
                model=".password_confirmation"
              />
              <SecurityQuestionAnswer
                answerControlId="userSecurityAnswer1"
                answerLabel="Security answer 1"
                answerModel="deep.about_you.user.security_answers_attributes[0].answer"
                questionControlId="userSecurityQuestion1"
                questionLabel="Security question 1"
                questionModel="deep.about_you.user.security_answers_attributes[0].security_question_id"
                questions={questions.filter(question => question.attributes['list-number'] === 1)}
              />

              <SecurityQuestionAnswer
                answerControlId="userSecurityAnswer2"
                answerLabel="Security answer 2"
                answerModel="deep.about_you.user.security_answers_attributes[1].answer"
                answerPlaceHolder="Security answer 2"
                questionControlId="userSecurityQuestion2"
                questionLabel="Security question 2"
                questionModel="deep.about_you.user.security_answers_attributes[1].security_question_id"
                questions={questions.filter(question => question.attributes['list-number'] === 2)}
              />

              <Control.checkbox component={Checkbox} className="terms" model=".t_cs1">
                I have read and understand the programme
                {' '}
                <Link
                  target="_blank"
                  to="/content-pages/terms-conditions"
                  className="link"
                >
                  terms & conditions
                </Link>
                .
              </Control.checkbox>
              {champion && (
                <Control.checkbox component={Checkbox} className="terms" model=".t_cs_champion">
                  I agree to the champion staff terms and conditions.
                  {' '}
                  <Link
                    target="_blank"
                    to="/content-pages/champion-terms-conditions"
                    className="link"
                  >
                    Read here
                  </Link>
                  .
                </Control.checkbox>
              )
              }
              <p className="font-size-14">
                Click{' '}
                <a className="link" href="/content-pages/privacy-policy" target="_blank">
                  here{' '}
                </a>
                to view the programme
                privacy policy and learn more about how we will use your data
              </p>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Button
                bsStyle="primary"
                className="red-btn float-right"
                disabled={!t_cs1 || !t_cs2 || !formValid || (champion && !t_cs_champion)}
                type="submit"
              >
                Next
              </Button>
            </Col>
          </Row>
        </Grid>

      </Form>
    );
  }
}

const mapStateToProps = state => ({
  eircode: state.aboutYou.outlet.eircode,
  passcode: state.aboutYou.outlet.passcode,
  customer_number: state.aboutYou.outlet.customer_number,
  questions: state.aboutYou.questions,
  champion: state.deep.about_you.user.champion,
  t_cs1: state.deep.about_you.user.t_cs1,
  t_cs2: state.deep.about_you.user.t_cs2,
  t_cs3: state.deep.about_you.user.t_cs3,
  t_cs_champion: state.deep.about_you.user.t_cs_champion,
  marketing: state.deep.about_you.user.marketing,
  marketingAccepted: state.deep.about_you.user.marketing_accepted,
  commsEmail: !!state.deep.about_you.user.comms_email,
  commsMobile: !!state.deep.about_you.user.comms_mobile,
  registration: state.registration,
  form: state.deep.forms.about_you.user,
  formValid: state.deep.forms.about_you.user.$form.valid,
});

export default connect(mapStateToProps)(InformationsAboutYou);



// WEBPACK FOOTER //
// ./src/components/about-you/index.jsx